import api from '../utils/functions/api';

const baseURL = process.env.REACT_APP_API_URL;

async function getProvincesApi() {
  try {
    const resp = await api.get(`${baseURL}/manage-users/get-provinces`);

    return resp.data;
  } catch (error) {
    console.log(error);
    throw new Error(error.message);
  }
}

async function getDistrictApi(id) {
  try {
    const resp = await api.get(`${baseURL}/manage-users/get-district/${id}`);

    return resp.data;
  } catch (error) {
    console.log(error);
    throw new Error(error.message);
  }
}

async function getSubDistrictApi(id) {
  try {
    const resp = await api.get(`${baseURL}/manage-users/get-subdistrict/${id}`);

    return resp.data;
  } catch (error) {
    console.log(error);
    throw new Error(error.message);
  }
}

async function getCustomerApi(search, page, rowsPerPage, sortBy) {
  try {
    const path = `manage-users/get-custormer-list?page=${page + 1}&size=${rowsPerPage}&sortBy=${sortBy}&search=${search}`;
    const resp = await api.get(`${baseURL}/${path}`);

    return resp.data;
  } catch (error) {
    console.log(error);
    throw new Error(error.message);
  }
}

async function createDebtorApi(
  taxType,
  fixedItem,
  branchID,
  branchName,
  isAddressValid,
  fixAddress,
  customerCode,
) {
  try {
    const resp = await api.post(`${baseURL}/manage-users/create`, {
      tax_id_type: taxType,
      ...fixedItem,
      branch_id: branchID,
      branch_name: branchName,
      customer_code: customerCode,
      address: isAddressValid ? fixAddress : null,
    });

    return resp;
  } catch (error) {
    console.log(error);
    throw new Error(error.response.data.message);
  }
}

async function deleteDebtorByIdApi(id) {
    try {
        const resp = await api.delete(`${baseURL}/manage-users/delete-user`,{
            data: {
                _id: id
            }
        });

        return resp;
    } catch (error) {
        console.log(error);
        throw new Error(error.message);
    }
}

async function updateDebtor(userID, body) {
    try {
        const resp = await api.put(`${baseURL}/manage-users/update-user/${userID}`, body);

        return resp.data;
    } catch (error) {
        console.log(error);
        throw new Error(error.response.data.error.message);
    }
}

const ConfigListApi = {
  getProvincesApi,
  getDistrictApi,
  getSubDistrictApi,
  getCustomerApi,
  createDebtorApi,
  deleteDebtorByIdApi,
  updateDebtor
};
export default ConfigListApi;
